import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin, Button, message, Modal } from 'antd';
import TopInfo from '../../../basicElement/TopInfo';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import CoUpdateView from './CoUpdateView';
import { getMatchOption } from '../../../shared/selectFn';
import format from '../../../shared/format';

const STATUS = {
    add: {
        add: true,
        title: '添加CO跟踪表',
    },
    edit: {
        edit: true,
        title: '修改CO跟踪表',
    },
    view: {
        view: true,
        title: '查看CO跟踪表',
    },
};

export default class CoUpdate extends Component {
    static contextTypes = {
        configure: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const { type } = props;
        this.config = STATUS[type];
        this.state = {
            data: {},
            loading: false,
            editable: this.config.edit,
        };
    }

    componentDidMount() {
        if (!this.config.add) {
            this.loadDetail();
        }
    }

    loadDetail = () => {
        const { record } = this.props;
        const { investigationId, coReasonIds } = record;
        record.coReasonIds = coReasonIds ? coReasonIds.split(',') : [];
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.queryInvestigationByName, {
            investigationId,
        }).then(res => {
            const { data } = res;
            const invparams = data && data.length > 0 ? data[0] : {};
            this.setState({
                data: {
                    investigation: invparams,
                    ...record,
                },
            }, () => this.queryInvInfo(investigationId, 'editFirstLoad'));
        }).catch(err => {
            this.setState({ loading: false });
        });
    }
  // 函数计算
    calcCoBackMonthPlanAmount = (data, invInfo) => {
        const {
            planCoAmount = 0,
            coRate = 6,
            coInAccountPlanPercent = 0,
            coBackMonthPlanInvoiceAmount = 0,
            investigation,
            coBackPmFinishPercent,
        } = data || {};
        const { contractTypeName } = investigation || {};
        const {
            // planSignPercentValue = 0,
            investigationContractAmount = 0,
            coCurrentMonthPercent = 0,
        } = invInfo || {};
        let result;
        if (contractTypeName == '开票') {
            result = coBackMonthPlanInvoiceAmount;
        } else if (contractTypeName == '不计收入' || contractTypeName == '招募') {
            result = 0;
        } else if (investigationContractAmount + Number(planCoAmount) === 0) { // bug 33864 除数为0结果为Infinity（无限大）
            result = 0;
        } else if (!coBackPmFinishPercent && coBackPmFinishPercent !== 0) {
            result = 0;
        } else {
            result = (((investigationContractAmount + Number(planCoAmount)) / (1 + coRate / 100) * (coBackPmFinishPercent / 100) - investigationContractAmount / (1 + coRate / 100) * Number(coCurrentMonthPercent / 100)) * (Number(planCoAmount) / (investigationContractAmount + Number(planCoAmount)))).toFixed(2);
        }
        return result;
    }

    calcCoFte = params => {
        const { planCoAmount = 0, coRate = 6 } = params || {};
        return Number((planCoAmount / ((1 + coRate / 100) * 25000)).toFixed(2));
    }

    caleCoInAccountPlanPercent = (data, invInfo) => {
        const {
            planCoAmount = 0,
            coRate = 6,
         } = data || {};
        const {
            planSignPercentValue = 0,
            percentTotalSecond = 0,
          } = invInfo || {};
        const denominator = this.calcCoFte({ planCoAmount, coRate }) + Number(percentTotalSecond);
        if (!(denominator > 0)) { // 分母为0或负数时除法结果为Infinity/负百分比（bug 33864同类问题），按0处理，与后端CoTraceManager口径一致
            return 0;
        }
        const res = ((planSignPercentValue / denominator) * 100).toFixed(2);
        return res == 'NaN' ? 0 : res;
    }
    // 函数计算 -- 结束

    handleChange = (data, key) => {
        // 此处项目简称选择，后台提供两个接口，组合后得到数据，解释器归后台
        const { data: invData } = this.state;
        if (key == 'investigation') {
            const { investigationId } = data || {};
            if (investigationId) {
                this.setState({
                    loading: true,
                }, () => this.queryInvInfo(investigationId));
            } else {
                invData.invInfo = {};
                invData.investigation = {};
                this.setState({
                    data: invData,
                });
            }
        } else if (key == 'planSignCompletedDate' || key == 'actualSignCompletedDate') {
            const { investigationId } = invData || {};
            if (!investigationId) {
                return message.warning('请选择项目简称！');
            }

            this.queryInvInfo(investigationId);
        } else {
            this.setState({ data });
        }
    }

    queryInvInfo = (investigationId, editFirstLoad) => {
        this.setState({
            loading: true,
        });
        const { data } = this.state;
        const { coTraceId, planSignCompletedDate, actualSignCompletedDate, coInvoiceRateId } = data || {};
        const { configure } = this.context;
        const { CO_INVOICE_RATE = [] } = configure;
        // 新增查询接口，获取 添加/修改 的部分信息
        Fetch.post(API_URL.investigation.queryInvInfo, {
            investigationId,
            coTraceId,
            planSignCompletedDate: planSignCompletedDate ? planSignCompletedDate.slice(0, 10) : '',
            actualSignCompletedDate: actualSignCompletedDate ? actualSignCompletedDate.slice(0, 10) : '',
        }).then(value => {
            const { invInfo } = value || {};
            data.invInfo = invInfo;
            const coRateValue = (CO_INVOICE_RATE || []).filter(item => item.coTraceConfigureId == (coInvoiceRateId || 25))[0].operationType;
            data.coRate = Number(coRateValue || 6);
            data.coInAccountPlanPercent = this.caleCoInAccountPlanPercent(data, invInfo);
            if (!editFirstLoad) {
                data.coBackMonthPlanAmount = this.calcCoBackMonthPlanAmount(data, invInfo);
            }
            setTimeout(() => {
                this.setState({
                    data,
                    loading: false,
                });
            }, 50);
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    handleSave = () => {
        const { record } = this.props;
        const { data } = this.state;
        const { invInfo, investigation = {} } = data || {};
        const { coTraceId } = record;

        if (!data.investigationId) {
            return message.warning('请选择项目简称！');
        }
        if (!(data.planCoAmount || data.planCoAmount == 0)) {
            return message.warning('请输入计划CO金额/人民币！');
        }
        if (!data.coPossibilityId) {
            return message.warning('请选择CO可能性');
        }
        if (!(data.coReasonIds && data.coReasonIds.length > 0)) {
            return message.warning('请选择CO原因');
        }
        if ((data.coReasonIds && data.coReasonIds.includes('12')) && !data.coReasonRemark) {
            return message.warning('请输入CO原因备注');
        }
        if (investigation.contractTypeName == '开票' && !(data.coBackMonthPlanInvoiceAmount || data.coBackMonthPlanInvoiceAmount == 0)) {
            return message.warning('请输入CO签回当月预计可开票金额');
        }
        if ((data.contractTypeName == '开票' && !(data.coBackMonthPlanInvoiceAmount || data.coBackMonthPlanInvoiceAmount == 0))) {
            return message.warning('请输入CO签回当月预计可开票金额');
        }
        if (!(data.coHappenedPercent || data.coHappenedPercent == 0)) {
            return message.warning('请输入CO中已发生工作占比');
        }
        if (!(data.customerAgreeCo == '1' || data.customerAgreeCo == '0')) {
            return message.warning('请选择客户是否认同可CO');
        }
        if (!(data.coAmountAgreement == '1' || data.coAmountAgreement == '0')) {
            return message.warning('请选择CO金额是否已达成一致');
        }
        if (data.haveDiscount == '1' && !(data.discountPercent || data.discountPercent == 0)) {
            return message.warning('请输入折扣比例');
        }
        if (data.coAmountAgreement == '1' && !(data.coFinalization == '1' || data.coFinalization == '0')) {
            return message.warning('请选择是否CO定稿');
        }
        if (data.coFinalization == '1' && !(data.coIsSigningProcess == '1' || data.coIsSigningProcess == '0')) {
            return message.warning('请选择是否已在签署流程');
        }
        if (data.coIsSigningProcess == '1' && !data.signingNode) {
            return message.warning('请输入签署节点');
        }
        if (!data.planSignCompletedDate) {
            return message.warning('请选择预计签署完成日期');
        }
        if (data.coAmountAgreement == '1' && !data.coBackPmFinishPercent && data.coBackPmFinishPercent !== 0) {
            return message.warning('请输入CO回来入账后PM对项目完工百分比预估%');
        }
        if (data.coIsSigningProcess == '1' && !(data.coUploadCtms == '1' || data.coUploadCtms == '0')) {
            return message.warning('请选择CO是否已上传CTMS');
        }
        if (!data.processContent) {
            return message.warning('请选择输入最近跟进进度（前面进度罗列）');
        }
        if (!data.keyBlocking) {
            return message.warning('请输入卡脖子关键环节');
        }

        data.coInvoiceRateId = data.coInvoiceRateId || 25; // CO发票税率 默认为 6%
        // 时间型数据处理
        data.planSignCompletedDate = data.planSignCompletedDate ? data.planSignCompletedDate.slice(0, 10) : '';
        data.actualSignCompletedDate = data.actualSignCompletedDate ? data.actualSignCompletedDate.slice(0, 10) : '';
        data.createTime = data.createTime ? data.createTime.slice(0, 10) : '';
        data.updateTime = data.updateTime ? data.updateTime.slice(0, 10) : '';
        data.coReasonIds = (data.coReasonIds && data.coReasonIds.length > 0) ? data.coReasonIds.join(',') : '';

        data.planSignPercentValue = invInfo ? invInfo.planSignPercentValue : '';
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.saveCoTrace, {
            coTraceId,
            ...data,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({ loading: false }, () => {
                this.props.update();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    cancel = () => {
        const { record } = this.props;
        this.cancelRef.show(record);
    }

    confirm = () => {
        const { record } = this.props;
        const { riskLevel, complaintRecordId } = record;
        Modal.confirm({
            title: `是否确认此投诉记录的风险等级（${riskLevel}）`,
            onOk: () => {
                this.setState({ loading: true });
                Fetch.post(API_URL.qualityManagement.updateIsCompleted, {
                    complaintRecordId,
                    isCompleted: 51,
                }).then(res => {
                    const { success } = res;
                    message.success(success);
                    this.setState({ loading: false }, () => {
                        this.props.update();
                    });
                }).catch(err => {
                    this.setState({ loading: false });
                });
            },
        });
    }

    render() {
        const { update, record } = this.props;
        const { data, loading, editable } = this.state;
        const { title, add, edit, confirm } = this.config;
        const { complaintRecordNumber } = record;
        const maxHeight = (document.body || document.documentElement).clientHeight - 258 - (editable || confirm ? 28 : 0);
        return (
            <div>
                <TopInfo
                    title={add || edit ? title : `${title}-${complaintRecordNumber}`}
                    onClick={() => update()}
                />
                <Spin spinning={loading}>
                    <div style={{ marginTop: 10, maxHeight, overflowX: 'hidden', overflowY: 'auto' }}>
                        <CoUpdateView
                            data={data}
                            editable={editable}
                            onChange={this.handleChange}
                            calcCoBackMonthPlanAmount={this.calcCoBackMonthPlanAmount}
                            caleCoInAccountPlanPercent={this.caleCoInAccountPlanPercent}
                        />
                    </div>
                </Spin>
                <div style={{ marginTop: 10, textAlign: 'center' }}>
                    <Button type="ghost" onClick={() => update()} disabled={loading}>取消</Button>
                    <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleSave} disabled={loading}>确定</Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/CoUpdate.js